module.exports = __webpack_public_path__ + "static/img/1-8.3051dc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/product/1-8.png
// module id = pllS
// module chunks = 15